export const currentPath = window.location.pathname
export const re = /\/(lists|search)\/?.*/
export function checkProSearchPath(re, currentPath) {
  if (currentPath.match(re)) {
    return true
  } else {
    return false
  }
}
